<template>
	<v-dialog v-model="dialogState" width="500">
		<v-card>
			<v-card-title class="headline primary white--text" primary-title>
				{{ header }}
			</v-card-title>

			<v-card-text>
				{{ content }}
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="success" flat @click="action">
					<v-icon color="white" class="mr-2">{{ icon }}</v-icon>
					{{ actionLabel }}
				</v-btn>
				<v-btn color="blue" @click="dialogState = false">
					<v-icon color="white" class="mr-2">close</v-icon>
					Anuluj
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "AgencyProjectConfirmationDialog",

		data () {
			return {
				dialogState: false,
			};
		},

		watch: {
			dialogModel: function () {
				this.dialogState = this.dialogModel;
			},

			dialogState: function (val) {
				if (!val) this.$emit("close-confirmation");
			}
		},

		props: {
			header: String,
			content: String,
			actionLabel: String,
			icon: String,
			action: Function,
			dialogModel: Boolean
		}
	};
</script>

<style scoped>

</style>
